import { Injectable } from '@angular/core';
import { Menu } from '../classes/menu';
import {API} from "./api.service";
import {Observable} from "rxjs";
import {Product} from "../classes/product";

@Injectable()
export class MenuService {
  private errorMessage : string;

  constructor(private api : API){}

  getMenus() : Observable<Menu[]> {
    return this.api.getMenus();
  }

  getProducts(menu : Menu) : Observable<Product[]> {
    return this.api.getProducts(menu);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/menu.service.ts